import React from "react";
import { motion } from "framer-motion";

const AboutUsBody3 = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="max-w-7xl mx-auto py-16 px-6 bg-[#29313F] text-white text-center rounded-xl shadow-md"
    >
      <h2 className="text-4xl font-bold mb-8 tracking-wide">Our Core Values</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {[
          { icon: '🏗️', title: 'Excellence', description: 'We are committed to delivering top-quality construction with precision and expertise.' },
          { icon: '🔨', title: 'Craftsmanship', description: 'Every project reflects our dedication to superior craftsmanship and innovation.' },
          { icon: '🛡️', title: 'Safety', description: 'We prioritize safety to protect our workers, clients, and communities.' },
          { icon: '🌍', title: 'Sustainability', description: 'Our projects integrate eco-friendly solutions for a greener future.' },
          { icon: '🤝', title: 'Integrity', description: 'We uphold honesty, transparency, and trust in every interaction.' },
          { icon: '📈', title: 'Growth', description: 'We continuously improve and innovate to lead the industry forward.' },
        ].map((value, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            className="bg-[#FFF] p-8 rounded-2xl shadow-lg transform hover:scale-105 transition-all"
          >
            <div className="text-6xl mb-4">{value.icon}</div>
            <h3 className="text-2xl text-[#29313F]  font-semibold mb-4">{value.title}</h3>
            <p className="text-lg text-[#29313F]">{value.description}</p>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default AboutUsBody3;
